export const GROUP_TO_TB = {
  '/testbed1': 'tbA',   // INTRA
  '/intra'   : 'tbA',

  '/testbed2': 'tbB',   // TMA
  '/tma'     : 'tbB',

  '/testbed3': 'tbC',   // THALES
  '/thales'  : 'tbC',

  '/testbed4': 'tbD',   // LMS
  '/lms'     : 'tbD',
};

export function resolveTestbedFromGroups(groups = []) {
  const hits = groups
    .map(g => String(g || '').toLowerCase())
    .map(g => GROUP_TO_TB[g])
    .filter(Boolean);
  return [...new Set(hits)];
}

// “Admin” = can access more than one testbed (keeps your existing logic working too)
export function isAdminFromGroups(groups = []) {
  return resolveTestbedFromGroups(groups).length > 1;
}
